export type BookingPersonPresentation = {
  slug: "rayk" | "katrin";
  name: string;
  firstName: string;
  initial: string;
};

export const RAYK_BOOKING_PERSON: BookingPersonPresentation = {
  slug: "rayk",
  name: "Rayk Schörling",
  firstName: "Rayk",
  initial: "R",
};

export const KATRIN_BOOKING_PERSON: BookingPersonPresentation = {
  slug: "katrin",
  name: "Katrin Schörling",
  firstName: "Katrin",
  initial: "K",
};

export function bookingPersonPresentation(requestedSlug: string | null): BookingPersonPresentation {
  return requestedSlug === "katrin" ? KATRIN_BOOKING_PERSON : RAYK_BOOKING_PERSON;
}
